import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const addEmailService = (body) => {
  return realBricksApi.post(`${API_ENDPOINTS.USERS.SendEmail}`, body)
}

export const addSmsService = (body) => {
  return realBricksApi.post(`${API_ENDPOINTS.USERS.SendSms}`, body)
}
export const getUsersService = (
  page,
  limit,
  sortField,
  sortType,
  userKYCStatus,
  userInvestmentStatus,
  regulationStatus,
  search
) => {
  let queryString = '';
  if (userKYCStatus?.length > 0) {
    queryString = `${queryString}&userKYCStatus=${userKYCStatus}`;
  }

  if (userInvestmentStatus?.length > 0) {
    queryString = `${queryString}&userInvestmentStatus=${userInvestmentStatus}`;
  }

  if(regulationStatus?.length > 0){
    queryString = `${queryString}&regulationStatus=${regulationStatus}`;
  }

  return realBricksApi.get(
    `${API_ENDPOINTS.USERS.GetUsers}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const getNonUSUsersService = (
  page,
  limit,
  sortField,
  sortType,
  search
) => {
  let queryString = '';

  return realBricksApi.get(
    `${API_ENDPOINTS.USERS.GetNonUSUsers}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const getDuplicateUsersService = (
    page,
    limit,
    sortField,
    sortType,
    userKYCStatus,
    userInvestmentStatus,
    regulationStatus,
    search,
    field,
) => {
  console.log(field,'field');
  return realBricksApi.get(`${API_ENDPOINTS.USERS.GetDuplicateUsers}`, {
    params: {
      page,
      limit,
      sortField,
      sortType,
      ...(search && { search }),
      ...(field && {field}),
      ...(userKYCStatus && { userKYCStatus }),
      ...(userInvestmentStatus && {userInvestmentStatus}),
      ...(regulationStatus && {regulationStatus})
    }
  })
};

export const freezeUserService = (userId, body) => {
  return realBricksApi.patch(
    `${API_ENDPOINTS.USERS.FreezeUser}/${userId}`,
    body
  );
};

export const getUserDetailsService = (userId) => {
  return realBricksApi.get(`${API_ENDPOINTS.USERS.UserDetails}/${userId}`);
};

export const getUserInvestedPropertiesService = (
  userId,
  page,
  limit,
  sortField,
  sortType
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.USERS.InvestedProperties}/${userId}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`
  );
};

export const getUserSavedPropertiesService = (
  userId,
  page,
  limit,
  sortField,
  sortType
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.USERS.SavedProperties}/${userId}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`
  );
};

export const searchUserByName = (search) => {
  return realBricksApi.get(`${API_ENDPOINTS.USERS.GetUsers}`, {
    params: {
      ...(search && { search }),
    },
  });
};

export const getAccountStatementService = (
  userId,
  page,
  limit,
  sortField,
  sortType,
  startDate,
  endDate
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.USERS.AccountStatement}/${userId}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  );
};

export const downloadAccountStatementService = (userId, body) => {
  return realBricksApi.post(
    `${API_ENDPOINTS.USERS.AccountStatement}/${userId}`,
    body,
    {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/pdf',
      },
    }
  );
};

export const manualKYCService = (userId) => {
  return realBricksApi.put(`${API_ENDPOINTS.USERS.ManualKYC}/${userId}`);
};

export const approveService = (id) => {
  return realBricksApi.put(`${API_ENDPOINTS.USERS.Approve}/${id}`);
}
export const getNotificationsServiceList = (
  page,
  limit,
  type
) => {
  return realBricksApi.get(`${API_ENDPOINTS.USERS.Notifications}?page=${page}&limit=${limit}&type=${type}`)
};

export const getNotificationUserServiceList = (
  page,
  limit,
  citizenshipStatus
) =>{
  return realBricksApi.get(`${API_ENDPOINTS.USERS.NotificationsUser}?page=${page}&limit=${limit}&citizenshipStatus=${citizenshipStatus}`)
}

export const downloadUserServices = (
  userType,
  sortField,
  sortType,
  userKYCStatus,
  userInvestmentStatus,
  regulationStatus,
  search,
) => {
  let queryString = '';

  queryString = userKYCStatus ? `${queryString}&userKYCStatus=${userKYCStatus}` : queryString;
  queryString = userInvestmentStatus ? `${queryString}&userInvestmentStatus=${userInvestmentStatus}` : queryString;
  queryString = regulationStatus ? `${queryString}&regulationStatus=${regulationStatus}` : queryString;

  return realBricksApi.get(
    `${API_ENDPOINTS.USERS.DownloadUsers}/${userType}?${queryString}`,
    {
      params: {
        ...(search && { search }),
      }
    }
  )
}

export const resetPinPasswordService = (userId, resetFor) => {
  return realBricksApi.post(`${API_ENDPOINTS.USERS.ResetPinPassword}`, {
    userId,
    resetFor
  })
};